import { useRef } from "react";
import { motion, useInView } from "framer-motion";

import { FaArrowRight } from "react-icons/fa";
import CircularBadge from "../components/badge";
import "./ApplyCTA.css";

const ease = [0.22, 1, 0.36, 1];
const fadeUp = (d = 0) => ({ hidden: { opacity: 0, y: 16 }, show: { opacity: 1, y: 0, transition: { duration: 0.6, ease, delay: d } } });

export default function ApplyCTA({ onBegin }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });

  return (
    <section className="acta" ref={ref} id="apply-form">
      {/* Mountain background */}
      <div className="acta__bg" aria-hidden="true">
        <div className="acta__overlay" />
      </div>

      <div className="acta__inner container-fg container-2xxl">
        {/* Left: circular badge */}
        <motion.div className="acta__badge" variants={fadeUp(0.05)} initial="hidden" animate={inView ? "show" : "hidden"}>
          <CircularBadge colors="var(--c-rust)" logoSize={32} />
        </motion.div>

        {/* Centre */}
        <motion.div className="acta__centre" variants={fadeUp(0.1)} initial="hidden" animate={inView ? "show" : "hidden"}>
          <h2 className="acta__headline u-display">Ready to Take the First Step?</h2>
          <p className="acta__sub">You don't have to walk this road alone.</p>
          <button type="button" className="acta__btn border-0" onClick={onBegin}>
            Begin Your Application <FaArrowRight aria-hidden="true" />
          </button>
        </motion.div>

        {/* Right: flower image + note */}
        <motion.div className="acta__note" variants={fadeUp(0.15)} initial="hidden" animate={inView ? "show" : "hidden"}>
          <img src="./assets/flower.png" alt="" className="acta__note-img" aria-hidden="true" />
          <p className="acta__note-text">
            Every application is reviewed
            <br />
            with care and respect.
            <br />
            We're honored you're here.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
